import React from 'react';
import styled from '@emotion/styled';

const HashtagModule = ({
  hashtag,
  className,
}: {
  hashtag?: string;
  className?: string;
}): JSX.Element => {
  const Container = styled.div``;
  return <Container className={className}>#{hashtag}</Container>;
};

export default HashtagModule;
